<alaris-dialog
	[closeAction]="close"
	[confirmAction]="confirm"
	[loading$]="service.loading$"
	[confirmButtonText]="'gl.delete'"
	size="md"
	class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>
			{{ 'simulation.removing_dialog_title' | translate }}
		</div>
	</h3>
	<div slot="content">
		<p>
			{{ 'simulation.removing_dialog' | translate }}
			<strong>DD-{{ task.id }}</strong>
		</p>
	</div>
</alaris-dialog>
